"use client"

import styled from "styled-components"
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts"
import {
  Badge,
  Card,
  CardHeader,
  StatGrid,
  StatLabel,
  StatValue,
  StatText,
  Subtitle,
  Title,
  TitleGroup,
} from "./primitives"

const curve = [
  { m: "Front", price: 71.2 },
  { m: "M+1", price: 70.6 },
  { m: "M+2", price: 70.1 },
  { m: "M+3", price: 69.7 },
  { m: "M+4", price: 69.4 },
  { m: "M+5", price: 69.2 },
]

const ChartWrap = styled.div`
  margin-top: 1.25rem;
  height: 8.5rem;
  width: 100%;
`

export function FuturesCurveCard() {
  return (
    <Card>
      <CardHeader>
        <TitleGroup>
          <Title>WTI Crude futures</Title>
          <Subtitle>Forward curve · $/bbl</Subtitle>
        </TitleGroup>
        <Badge tone="alert">Backwardation</Badge>
      </CardHeader>

      <ChartWrap>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={curve} margin={{ top: 10, right: 8, bottom: 0, left: -12 }}>
            <CartesianGrid stroke="var(--color-border)" strokeDasharray="3 3" vertical={false} />
            <XAxis
              dataKey="m"
              tickLine={false}
              axisLine={false}
              tick={{ fill: "var(--color-muted-foreground)", fontSize: 11 }}
              dy={6}
            />
            <YAxis
              domain={[68, 72]}
              tickLine={false}
              axisLine={false}
              tick={{ fill: "var(--color-muted-foreground)", fontSize: 11 }}
              width={40}
              ticks={[68, 70, 72]}
            />
            <Line
              type="monotone"
              dataKey="price"
              stroke="var(--color-caution)"
              strokeWidth={3}
              dot={{ r: 3.5, fill: "var(--color-caution)", strokeWidth: 0 }}
              isAnimationActive={false}
            />
          </LineChart>
        </ResponsiveContainer>
      </ChartWrap>

      <StatGrid>
        <div>
          <StatLabel>Front month</StatLabel>
          <StatValue>$71.20</StatValue>
        </div>
        <div>
          <StatLabel>Roll yield</StatLabel>
          <StatValue $tone="alert">-2.8%</StatValue>
        </div>
        <div>
          <StatLabel>Open interest</StatLabel>
          <StatText>1.6M</StatText>
        </div>
      </StatGrid>
    </Card>
  )
}

export default FuturesCurveCard
